var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoCircleGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.478 2 2 6.48 2 12c0 5.524 4.478 10 10 10 5.523 0 10-4.476 10-10 0-5.52-4.477-10-10-10zm0 18.064A8.06 8.06 0 013.935 12 8.062 8.062 0 0112 3.935 8.062 8.062 0 0120.064 12 8.06 8.06 0 0112 20.064zm0-13.629a1.694 1.694 0 110 3.388 1.694 1.694 0 010-3.388zm2.258 10.242a.484.484 0 01-.484.484h-3.548a.484.484 0 01-.484-.484v-.967c0-.268.217-.484.484-.484h.484v-2.58h-.484a.484.484 0 01-.484-.485v-.967c0-.268.217-.484.484-.484h2.58c.268 0 .484.216.484.483v4.033h.484c.267 0 .484.216.484.484v.967z",
    fill: "#777"
  })));
}

export default SvgInfoCircleGray;